<template>
  <div>
    <component
      :is="itemComponent"
      :data="data"
      :placeholder="placeholder"
      :get-data="getData"
      @change="handleChange"
    />
  </div>
</template>

<script>
import { getQueitTeam, getAuthTeamInfo } from '@/services/index'
import MyInput from '@/pc/inquery/filterItem/Input'
import MyCheckbox from './CheckBox'
import InfotypeCheckbox from '@/pc/inquery/filterItem/InfoTypeCheckbox'
import SelectTree from '@/pc/inquery/formItem/SelectTree'
import MyArea from '@/pc/inquery/formItem/Area'
import CascaderGroup from '@/pc/inquery/filterItem/CascaderGroup'
import DateGroup from '@/pc/inquery/filterItem/DateGroup'
import InputGroup from '@/pc/inquery/filterItem/InputGroup'
import eventBus from '@/lib/eventBus'

export default {
  props: {
    'data': {
      type: [Object, Array, String, Boolean],
      default: () => { }
    },
    dia: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      itemComponent: ''
    }
  },
  computed: {
    inquiryId () {
      return this.$route.params.inquiryId
    },
    placeholder () {
      if (!this.data) return

      const { fieldname = '', fieldconfig = {} } = this.data || {}
      const { placeholder = '' } = fieldconfig

      let string = placeholder || this.$t('message["855"]') + fieldname

      return string
    }
  },
  watch: {
    data: {
      handler (val) {
        this.setItem()
      },
      deep: true
    },
    dia (val) {
      if (val) {
        this.setItem()
      }
    }
  },
  created () {
    this.setItem()
    eventBus.$on('setItem', () => {
      this.setItem()
    })
  },
  methods: {
    setItem () {
      let { fieldtype, fieldconfig = {} } = this.data || {}
      const { info_sign: infoSign = {} } = fieldconfig
      let fieldvalue = this.data.fieldvalue
      let value = fieldvalue

      switch (fieldtype) {
        case 'text':
        case 'ip':
          this.itemComponent = MyInput
          break
        case 'number':
          this.itemComponent = InputGroup
          value = fieldvalue || {} // min max
          break
        case 'phone':
        case 'email':
          this.itemComponent = MyInput
          value = fieldvalue || []
          break
        case 'select':
        case 'radio':
        case 'radioinfo_payfor':
        case 'radioinfo_level':
        case 'radioinfo_followup':
        case 'checkbox':
          this.itemComponent = MyCheckbox
          value = fieldvalue || []
          break

        case 'radioinfo_type':
          this.itemComponent = InfotypeCheckbox
          value = fieldvalue || []
          if (this.data.fieldconfig && this.data.fieldconfig.info_sign) {
            this.$set(this.data.fieldconfig.info_sign, 'fieldvalue', infoSign.fieldvalue)
          }
          break
        case 'selectrolegroup':
        case 'selectfollowuser':
        case 'selectuser':
          // this.data.fieldtype = 'selectuser'
          this.itemComponent = CascaderGroup
          value = fieldvalue || {} // roleid, groupid, userid
          break
        case 'from_info':
          this.itemComponent = CascaderGroup
          this.data.options = this.data.child
          value = fieldvalue || []
          break
        case 'select_tree':
          this.itemComponent = SelectTree
          this.data.fieldconfig.enableinput = 0
          value = fieldvalue || []
          break
        case 'timezones': // 时间区间
          this.itemComponent = DateGroup
          value = fieldvalue || {}
          break
        case 'area':
          this.itemComponent = MyArea
          this.data.fieldconfig.enableinput = 0
          this.data.fieldconfig.showSearch = 0
          value = fieldvalue || []
          break
      }
      this.$set(this.data, 'fieldvalue', value)
      this.$forceUpdate()
    },
    async getData (obj) {
      let { fieldkey = '' } = obj
      let params = {}
      let result
      let key = fieldkey && fieldkey.split('_') && fieldkey.split('_')[0]
      console.log(obj)
      if (key === 'dev_roleid_groupid') { // 所属团队小组
        // params = { pk: 'inquiry-audit' }
        params = { pk: `inquiry-${key}`, userid: this.$route.query.userid }

        // result = await getAuthTeamInfo()
        result = await getQueitTeam()
          .params(params).fetch()
      } else {
        if (key === 'follow') {
          key = 'followup'
          if (this.$route.query.scope === 'dev') {
            params = { pk: `inquiry-${key}` }
            result = await getAuthTeamInfo()
              .params(params).fetch()
          } else {
            params = { pk: `inquiry-${key}`, userid: this.$route.query.userid }

            result = await getQueitTeam()
              .params(params).fetch()
          }
        } else {
          if (key === 'dev') {
            if (this.$route.query.scope === 'input' || this.$route.query.scope === 'audit') {
              params = { pk: `inquiry-${key}` }
              result = await getAuthTeamInfo()
                .params(params).fetch()
            }
          } else {
            if (key === 'input') { key = 'add' }
            params = { pk: `inquiry-${key}`, userid: this.$route.query.userid }

            // result = await getAuthTeamInfo()
            result = await getQueitTeam()
              .params(params).fetch()
          }
        }
      }

      const { payload: data = [] } = (result && result.data) || {}

      return data
    },
    handleChange (val) {
      this.data.fieldvalue = val
      this.$emit('change', val)
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
